import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { elakayAutoText, getElakayLanguageContext } from "./dataElakay";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;
const __elakayText = (key, fallback) =>
  __elakayLanguageSource()?.laguangeElakay?.("frontElakayHardcodedText", __elakayLanguageSource().languageAPI)?.["stripeaccountcreationmodal"]?.[key] || fallback;

// ============================================
// FONCTION POUR RÉCUPÉRER LA POLITIQUE PAR LANGUE
// ============================================


function getStripePolicyByLang(policyData, ids = [], langCode = "fr") {
    if (!policyData || !Array.isArray(policyData)) return null;
    
    const policy =
        policyData.find((p) => p.language === langCode) ||
        policyData.find((p) => p.language === "en");

    if (!policy || !Array.isArray(policy.sections)) {
        return policy || null;
    }

    if (!ids.length) {
        return policy;
    }

    const idStrings = ids.map(String);

    return {
        ...policy,
        sections: policy.sections.filter((section) =>
            idStrings.includes(section.id)
        ),
    };
}

// ============================================
// FONCTION POUR TRONQUER LE TEXTE
// ============================================
function getPreview(text, maxChars = 300) {
    if (!text) return "";
    if (text.length <= maxChars) return text;
    return text.slice(0, maxChars) + "…";
}

// ============================================
// COMPOSANT PRINCIPAL
// ============================================
const StripeAccountCreationModal = ({
    showModal,
    setShowModal,
    laguangeElakay,
    infoSource,
    token,
    createStripeAccount,
    userType = 'client',
    policyData = [],
    langCode = 'en',
    policySectionIds = []
}) => {
  __setElakayInfoSource(infoSource);
    // États
    const [isAgreed, setIsAgreed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [currentPage, setCurrentPage] = useState(0); // 0 = page création compte
    const [expandedSections, setExpandedSections] = useState({});

    // Récupération de la politique
    const policy = getStripePolicyByLang(policyData, policySectionIds, langCode);
    const sections = policy?.sections || [];

    // Pagination: Page 0 = création compte, Pages 1+ = sections de politique (2 par page)
    const sectionsPerPage = 3;
    const totalPolicyPages = Math.ceil(sections.length / sectionsPerPage);
    const totalPages = 1 + totalPolicyPages; // 1 pour la page de création + pages de politique

    // Sections à afficher sur la page courante (si page > 0)
    const getCurrentPolicySections = () => {
        if (currentPage === 0) return [];
        const policyPageIndex = currentPage - 1;
        const startIndex = policyPageIndex * sectionsPerPage;
        const endIndex = startIndex + sectionsPerPage;
        return sections.slice(startIndex, endIndex);
    };

    // Textes multilingues
    const texts = {
        fr: {
            modalTitle: "Politique et Paiement",
            clientBenefitsTitle: "En tant que client, vous pourrez :",
            sellerBenefitsTitle: "En tant que vendeur, vous pourrez :",
            agreeText: "J'accepte de créer un compte Stripe et j'ai lu et accepté les",
            termsLink: "conditions d'utilisation de Stripe",
            privacyLink: "politique de confidentialité",
            andThe: "ainsi que la",
            cancelBtn: "Annuler",
            createBtn: "Créer mon compte Stripe",
            creatingBtn: "Création en cours...",
            securityNote: "Vos informations sont sécurisées et cryptées. Stripe est certifié PCI DSS Level 1, le plus haut niveau de certification.",
            errorAgree: "Veuillez accepter les conditions pour continuer.",
            errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
            seeMore: "Voir plus",
            seeLess: "Voir moins",
            previous: "Précédent",
            next: "Suivant",
            section: "Section",
            page: "Page",
        },
        en: {
            modalTitle: "Policy and Payment",
            clientBenefitsTitle: "As a customer, you will be able to:",
            sellerBenefitsTitle: "As a seller, you will be able to:",
            agreeText: "I agree to create a Stripe account and have read and accepted the",
            termsLink: "Stripe Terms of Service",
            privacyLink: "Privacy Policy",
            andThe: "as well as the",
            cancelBtn: "Cancel",
            createBtn: "Create my Stripe account",
            creatingBtn: "Creating...",
            securityNote: "Your information is secure and encrypted. Stripe is PCI DSS Level 1 certified, the highest level of certification.",
            errorAgree: "Please accept the terms to continue.",
            errorGeneric: "An error occurred. Please try again.",
            seeMore: "See more",
            seeLess: "See less",
            previous: "Previous",
            next: "Next",
            section: "Section",
            page: "Page",
        },
        es: {
            modalTitle: "Política y Pago",
            clientBenefitsTitle: "Como cliente, podrás:",
            sellerBenefitsTitle: "Como vendedor, podrás:",
            agreeText: "Acepto crear una cuenta Stripe y he leído y aceptado los",
            termsLink: "Términos de Servicio de Stripe",
            privacyLink: "Política de Privacidad",
            andThe: "así como la",
            cancelBtn: "Cancelar",
            createBtn: "Crear mi cuenta Stripe",
            creatingBtn: "Creando...",
            securityNote: "Tu información está segura y encriptada. Stripe está certificado PCI DSS Nivel 1, el más alto nivel de certificación.",
            errorAgree: "Por favor, acepta los términos para continuar.",
            errorGeneric: "Ocurrió un error. Por favor, inténtalo de nuevo.",
            seeMore: "Ver más",
            seeLess: "Ver menos",
            previous: "Anterior",
            next: "Siguiente",
            section: "Sección",
            page: "Página",
        },
        ht: {
            modalTitle: "Politik ak Peman",
            clientBenefitsTitle: "Kòm kliyan, ou pral kapab:",
            sellerBenefitsTitle: "Kòm vandè, ou pral kapab:",
            agreeText: "Mwen dakò pou kreye yon kont Stripe epi mwen li ak aksepte",
            termsLink: "Kondisyon Sèvis Stripe",
            privacyLink: "Politik Konfidansyalite",
            andThe: "ansanm ak",
            cancelBtn: "Anile",
            createBtn: "Kreye kont Stripe mwen",
            creatingBtn: "Ap kreye...",
            securityNote: "Enfòmasyon ou yo an sekirite epi chifre. Stripe sètifye PCI DSS Nivo 1, pi wo nivo sètifikasyon an.",
            errorAgree: "Tanpri aksepte kondisyon yo pou kontinye.",
            errorGeneric: "Yon erè te pase. Tanpri eseye ankò.",
            seeMore: "Wè plis",
            seeLess: "Wè mwens",
            previous: "Anvan",
            next: "Swivan",
            section: "Seksyon",
            page: "Paj",
        },
        pt: {
            modalTitle: "Política e Pagamento",
            clientBenefitsTitle: "Como cliente, você poderá:",
            sellerBenefitsTitle: "Como vendedor, você poderá:",
            agreeText: "Aceito criar uma conta Stripe e li e aceitei os",
            termsLink: "Termos de Serviço da Stripe",
            privacyLink: "Política de Privacidade",
            andThe: "bem como a",
            cancelBtn: "Cancelar",
            createBtn: "Criar minha conta Stripe",
            creatingBtn: "Criando...",
            securityNote: "Suas informações estão seguras e criptografadas. Stripe é certificada PCI DSS Nível 1, o mais alto nível de certificação.",
            errorAgree: "Por favor, aceite os termos para continuar.",
            errorGeneric: "Ocorreu um erro. Por favor, tente novamente.",
            seeMore: "Ver mais",
            seeLess: "Ver menos",
            previous: "Anterior",
            next: "Próximo",
            section: "Seção",
            page: "Página",
        },
    };

    const t = texts[langCode] || texts.fr;

    // Avantages selon le type d'utilisateur
    const clientBenefits = [
        { icon: '💳', title: __elakayText("t001", "Secure payments"), description: __elakayText("t002", "Effectuez vos achats en toute sécurité avec une protection complète.") },
        { icon: '🔄', title: __elakayText("t003", "Transaction history"), description: __elakayText("t004", "Accédez à l'historique complet de vos paiements.") },
        { icon: '⚡', title: __elakayText("t005", "Fast payments"), description: __elakayText("t006", "Enregistrez vos méthodes de paiement pour des achats plus rapides.") },
        { icon: '🛡️', title: __elakayText("t007", "Buyer protection"), description: __elakayText("t008", "Bénéficiez d'une protection en cas de litige.") }
    ];

    const sellerBenefits = [
        { icon: '💰', title: __elakayText("t009", "Recevoir des paiements"), description: __elakayText("t010", "Acceptez les paiements de vos clients directement sur votre compte.") },
        { icon: '🔄', title: __elakayText("t011", "Transferts automatiques"), description: __elakayText("t012", "Recevez vos fonds automatiquement sur votre compte bancaire.") },
        { icon: '💳', title: __elakayText("t013", "Paiements clients"), description: __elakayText("t014", "Effectuez également vos propres achats sur la plateforme.") },
        { icon: '📊', title: __elakayText("t015", "Gestion de paie (Payroll)"), description: __elakayText("t016", "Gérez les paiements de vos employés et collaborateurs.") },
        { icon: '📈', title: __elakayText("t017", "Tableau de bord"), description: __elakayText("t018", "Suivez vos ventes et revenus en temps réel.") },
        { icon: '🌍', title: __elakayText("t019", "Paiements internationaux"), description: __elakayText("t020", "Acceptez les paiements de clients du monde entier.") }
    ];

    const benefits = userType === 'seller' ? sellerBenefits : clientBenefits;

    // Handlers
    const handleSubmit = async () => {
        if (!isAgreed) {
            setError(t.errorAgree);
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            if (createStripeAccount) {
                await createStripeAccount(token, userType);
            }
            setShowModal(false);
            setIsAgreed(false);
            setCurrentPage(0);
        } catch (err) {
            setError(t.errorGeneric);
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setShowModal(false);
        setIsAgreed(false);
        setError('');
        setCurrentPage(0);
        setExpandedSections({});
    };

    const toggleExpand = (id) => {
        setExpandedSections((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const goToNextPage = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    // ============================================
    // RENDER PAGE 0: Création de compte
    // ============================================
    const renderAccountCreationPage = () => (
        <>
            {/* Message principal avec titre et résumé de la politique */}
            <div style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                padding: '1.5rem',
                marginBottom: '1.5rem',
                borderLeft: '4px solid #667eea'
            }}>
                <h4 style={{ color: '#333', marginBottom: '1rem' }}>
                    📋 {policy?.title || elakayAutoText("h_50208691130ed0", "Politique de responsabilité sur les paiements et rôle de Stripe")}
                </h4>
                <p style={{ color: '#666', margin: 0, lineHeight: '1.6' }}>
                    {policy?.summary || elakayAutoText("h_c941a6ca7d64e2", "Ce document explique en détail que la plateforme ne gère ni ne détient directement les paiements des utilisateurs. Tous les traitements de paiement sont gérés par Stripe, un prestataire de services de paiement tiers.")}
                </p>
            </div>

            {/* Titre des avantages */}
            <h5 style={{ 
                color: '#333', 
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            }}>
                ✨ {userType === 'seller' ? t.sellerBenefitsTitle : t.clientBenefitsTitle}
            </h5>

            {/* Liste des avantages */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '1rem',
                marginBottom: '1.5rem'
            }}>
                {benefits.map((benefit, index) => (
                    <div 
                        key={index}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e9ecef',
                            borderRadius: '10px',
                            padding: '1rem',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            cursor: 'default'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
                            {benefit.icon}
                        </div>
                        <h6 style={{ color: '#333', marginBottom: '0.25rem', fontWeight: '600' }}>
                            {benefit.title}
                        </h6>
                        <p style={{ color: '#666', fontSize: '0.85rem', margin: 0, lineHeight: '1.4' }}>
                            {benefit.description}
                        </p>
                    </div>
                ))}
            </div>

            {/* Checkbox d'accord */}
            <div style={{
                backgroundColor: '#fff',
                border: '2px solid #e9ecef',
                borderRadius: '10px',
                padding: '1rem',
                marginBottom: '1rem'
            }}>
                <label style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '0.75rem',
                    cursor: 'pointer',
                    margin: 0
                }}>
                    <input
                        type="checkbox"
                        checked={isAgreed}
                        onChange={(e) => {
                            setIsAgreed(e.target.checked);
                            if (e.target.checked) setError('');
                        }}
                        style={{
                            width: '20px',
                            height: '20px',
                            marginTop: '2px',
                            accentColor: '#667eea',
                            cursor: 'pointer'
                        }}
                    />
                    <span style={{ color: '#333', lineHeight: '1.5' }}>
                        {t.agreeText}{' '}
                        <a 
                            href="https://stripe.com/legal" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: '#667eea' }}
                        >
                            {t.termsLink}
                        </a>
                        {' '}{t.andThe}{' '}
                        <a 
                            href="https://stripe.com/privacy" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ color: '#667eea' }}
                        >
                            {t.privacyLink}
                        </a>.
                    </span>
                </label>
            </div>

            {/* Message d'erreur */}
            {error && (
                <div style={{
                    backgroundColor: '#fee2e2',
                    color: '#dc2626',
                    padding: '0.75rem 1rem',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    fontSize: '0.9rem'
                }}>
                    ⚠️ {error}
                </div>
            )}

            {/* Boutons d'action */}
            {/* <div style={{
                display: 'flex',
                gap: '1rem',
                justifyContent: 'flex-end',
                flexWrap: 'wrap'
            }}>
                <button
                    onClick={handleClose}
                    style={{
                        padding: '0.75rem 1.5rem',
                        borderRadius: '8px',
                        border: '1px solid #d1d5db',
                        backgroundColor: '#fff',
                        color: '#374151',
                        fontSize: '1rem',
                        fontWeight: '500',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f3f4f6';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#fff';
                    }}
                >
                    {t.cancelBtn}
                </button>
                <button
                    onClick={handleSubmit}
                    disabled={!isAgreed || isLoading}
                    style={{
                        padding: '0.75rem 2rem',
                        borderRadius: '8px',
                        border: 'none',
                        background: isAgreed 
                            ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                            : '#d1d5db',
                        color: 'white',
                        fontSize: '1rem',
                        fontWeight: '600',
                        cursor: isAgreed && !isLoading ? 'pointer' : 'not-allowed',
                        transition: 'all 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem'
                    }}
                >
                    {isLoading ? (
                        <>
                            <span style={{
                                width: '16px',
                                height: '16px',
                                border: '2px solid #fff',
                                borderTopColor: 'transparent',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                            }}></span>
                            {t.creatingBtn}
                        </>
                    ) : (
                        <>
                            🚀 {t.createBtn}
                        </>
                    )}
                </button>
            </div> */}

            {/* Note de sécurité */}
            <div style={{
                marginTop: '1.5rem',
                padding: '1rem',
                backgroundColor: '#f0fdf4',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
            }}>
                <span style={{ fontSize: '1.25rem' }}>🔒</span>
                <p style={{ margin: 0, color: '#166534', fontSize: '0.85rem', lineHeight: '1.4' }}>
                    {t.securityNote}
                </p>
            </div>
        </>
    );

    // ============================================
    // RENDER PAGES 1+: Sections de politique
    // ============================================
    const renderPolicyPage = () => {
        const currentSections = getCurrentPolicySections();

        return (
            <>
                {/* Titre de la section politique */}
                <div style={{
                    backgroundColor: '#f8f9fa',
                    borderRadius: '12px',
                    padding: '1.5rem',
                    marginBottom: '1.5rem',
                    borderLeft: '4px solid #667eea'
                }}>
                    <h4 style={{ color: '#333', marginBottom: '0.5rem' }}>
                        📜 {policy?.title || elakayAutoText("h_856cce633b0cb7", "Politique de paiement")}
                    </h4>
                    <p style={{ color: '#666', margin: 0, fontSize: '0.9rem' }}>
                        {t.page} {currentPage + 1} / {totalPages}
                    </p>
                </div>

                {/* Sections de la politique */}
                {currentSections.map((section) => {
                    const isExpanded = expandedSections[section.id];
                    const previewText = getPreview(section.body, 300);

                    return (
                        <div
                            key={section.id}
                            style={{
                                backgroundColor: '#fff',
                                border: '1px solid #e9ecef',
                                borderRadius: '10px',
                                padding: '1.5rem',
                                marginBottom: '1rem',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            <div style={{
                                display: 'inline-block',
                                padding: '4px 12px',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: '#fff',
                                borderRadius: '20px',
                                fontSize: '0.75rem',
                                fontWeight: '600',
                                marginBottom: '0.75rem',
                                textTransform: 'uppercase'
                            }}>
                                {t.section} {section.id}
                            </div>

                            <h5 style={{
                                color: '#333',
                                margin: '0 0 0.75rem 0',
                                fontSize: '1.1rem',
                                fontWeight: '600'
                            }}>
                                {section.title}
                            </h5>

                            <p style={{
                                color: '#666',
                                fontSize: '0.9rem',
                                lineHeight: '1.7',
                                margin: '0 0 0.75rem 0',
                                whiteSpace: 'pre-line'
                            }}>
                                {isExpanded ? section.body : previewText}
                            </p>

                            {section.body.length > 300 && (
                                <button
                                    onClick={() => toggleExpand(section.id)}
                                    style={{
                                        padding: '6px 16px',
                                        borderRadius: '20px',
                                        border: '1px solid #d1d5db',
                                        backgroundColor: '#f9fafb',
                                        color: '#667eea',
                                        fontSize: '0.85rem',
                                        fontWeight: '500',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = '#ede9fe';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                    }}
                                >
                                    {isExpanded ? `↑ ${t.seeLess}` : `↓ ${t.seeMore}`}
                                </button>
                            )}
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <Modal
                    size="lg"
                    show={showModal}
                    onHide={handleClose}
                    dialogClassName="modal-90w"
                    centered
                    aria-labelledby="stripe-account-modal-title"
                >
                    <Modal.Header closeButton style={{ 
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white'
                    }}>
                        <Modal.Title id="stripe-account-modal-title">
                            <h2 style={{ margin: 0, fontSize: '1.5rem' }}>
                                🏦 {t.modalTitle}
                            </h2>
                        </Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body style={{ padding: '2rem' }}>
                        {/* Contenu selon la page */}
                        {currentPage === 0 ? renderAccountCreationPage() : renderPolicyPage()}

                        {/* Navigation de pagination */}
                        {totalPages > 1 && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '1rem',
                                marginTop: '1.5rem',
                                paddingTop: '1.5rem',
                                borderTop: '1px solid #e9ecef'
                            }}>
                                <button
                                    onClick={goToPrevPage}
                                    disabled={currentPage === 0}
                                    style={{
                                        padding: '8px 20px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        background: currentPage === 0 
                                            ? '#e2e8f0' 
                                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: currentPage === 0 ? '#94a3b8' : '#fff',
                                        fontSize: '0.9rem',
                                        fontWeight: '500',
                                        cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    ← {t.previous}
                                </button>

                                <span style={{ 
                                    fontSize: '0.9rem', 
                                    color: '#666',
                                    fontWeight: '500'
                                }}>
                                    {t.page} {currentPage + 1} / {totalPages}
                                </span>

                                <button
                                    onClick={goToNextPage}
                                    disabled={currentPage === totalPages - 1}
                                    style={{
                                        padding: '8px 20px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        background: currentPage === totalPages - 1 
                                            ? '#e2e8f0' 
                                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: currentPage === totalPages - 1 ? '#94a3b8' : '#fff',
                                        fontSize: '0.9rem',
                                        fontWeight: '500',
                                        cursor: currentPage === totalPages - 1 ? 'not-allowed' : 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                >
                                    {t.next} →
                                </button>
                            </div>
                        )}
                    </Modal.Body>
                </Modal>

                {/* CSS pour l'animation de chargement */}
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </div>
        </div>
    );
};

export default StripeAccountCreationModal;